import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import { CREDIT_KARMA_OFFER_ENABLED } from "@/config/featureFlags";
import { Navigate } from "@/lib/router-compat";
import CheckMyScore from "@/pages/CheckMyScore";

export const Route = createFileRoute("/check-my-score")({
  head: () => seoHead("/check-my-score"),
  component: () => (CREDIT_KARMA_OFFER_ENABLED ? <CheckMyScore /> : <Navigate to="/credit-readiness" replace />),
});
